import gql from "graphql-tag";

export const VERIFY_CODE_FOR_TWO_FACTOR_AUTH_SETUP = gql`
  mutation VerifyCodeForTwoFactorAuthSetup($code: String!) {
    appToken: verifyCodeForTwoFactorAuthSetup(code: $code)
  }
`;
